import { classNames } from '../../../../../shared/types/className';
import { ChevronDown, ClipboardList } from 'lucide-react';
import logo from '../../../../../assets/images/logos/logo-victoria.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import { useParams } from 'react-router-dom';

interface TopBarProps {
    onToggleQuick: () => void;
    quickOpen: boolean;
    setIsOpenModal: (v: boolean) => void;
    setIsOnlyView: (v: boolean) => void;
}

export const TopBar = ({
    onToggleQuick,
    quickOpen,
    setIsOpenModal,
    setIsOnlyView,
}: TopBarProps) => {
    const { idTender } = useParams();

    return (
        <div className="topbar">
            <div className="topbar__left">
                <img
                    src={logo}
                    width={80}
                    alt="Logo"
                    className="logo-rounded"
                />
                <div className="topbar__title">Victoria · Licitaciones</div>
            </div>

            <div
                className="topbar__actions"
                style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
            >
                {idTender && (
                    <>
                        <Tooltip title="Ver">
                            <IconButton
                                size="small"
                                onClick={() => {
                                    setIsOpenModal(true);
                                    setIsOnlyView(true);
                                }}
                            >
                                <VisibilityIcon
                                    type="submit"
                                    sx={{ color: 'primary.main' }}
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                            <IconButton
                                size="small"
                                onClick={() => {
                                    setIsOpenModal(true);
                                    setIsOnlyView(false);
                                }}
                            >
                                <EditIcon
                                    type="submit"
                                    sx={{ color: 'primary.main' }}
                                />
                            </IconButton>
                        </Tooltip>
                    </>
                )}

                <button onClick={onToggleQuick} className="topbar__button">
                    <ClipboardList className="topbar__icon" />
                    Ver instrucciones
                    <ChevronDown
                        className={classNames(
                            'topbar__chevron',
                            quickOpen ? 'topbar__chevron--open' : ''
                        )}
                    />
                </button>
            </div>
        </div>
    );
};
